import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import type { MarketCode } from '../../@types/Token';
import { getMarket } from '../../utils/market';
import useBranch from './useBranch';

const useMarketCode = (): [MarketCode | undefined, RequestStateQuery] => {
  const market = getMarket();
  if (market?.externalView)
    return [market.marketCode, { isLoading: false, isSuccess: true, isError: false }];

  const [branch, request] = useBranch();
  return [
    request.isSuccess ? (branch?.marketCode === undefined ? 'SE' : branch.marketCode) : undefined,
    request,
  ];
};

export default useMarketCode;
